import iposApi from '../../api/iposApi';
import {hideLoading, showLoading} from './loadingActions';

export const setPayments = data => ({
  type: 'SET_PAYMENTS',
  data,
});

export const setClientPaymentData = data => ({
  type: 'SET_CLIENT_PAYMENT_DATA',
  data,
});

export const setClientTips = data => ({
  type: 'SET_CLIENT_TIPS',
  data,
});

export const setPaymentAmount = data => ({
  type: 'SET_PAYMENT_AMOUNT',
  data,
});

export const setClientTipType = data => ({
  type: 'SET_CLIENT_TIP_TYPE',
  data,
});

export const submitWebPayment = orderUuid => async (dispatch, getState) => {
  const {branchInfo, clientPaymentData, clientTips, clientPaymentAmount} = getState();
  dispatch(showLoading('מבצע תשלום...\n' +
      'נא לא לסגור את הדפדפן'));

  const paymentData = [{
    payment_type_id: 3,
    amount: clientPaymentAmount,
    card_number: clientPaymentData.cardNumber.replaceAll(/\s/g, ''),
    exp_date: clientPaymentData && `${clientPaymentData.expiryMonth} / ${clientPaymentData.expiryYear}`,
    cvv: clientPaymentData.cvc,
    tips: +clientTips * 100,
    passport_id: clientPaymentData.passport,
    phone: clientPaymentData.phone,
    pin_pad_id: (branchInfo.use_pin_pad_flg === 1) ? branchInfo.pin_pad_id : null,
  }];

  const data = {
    branch_id: branchInfo.branch_guid_code,
    guid_code: orderUuid,
    payments: paymentData,
  };

  const url = '/SubmitPayment';

  const res = await iposApi.post(url, data).then(response => response.data).catch((err) => {
    dispatch(hideLoading());
    throw err;
  });

  if (res.payments && res.payments.length > 0) {
    await dispatch(setPayments(res.payments));
  }

  dispatch(hideLoading());

  return res;
};

export const submitDejavooWebPayment = orderUuid => async (dispatch, getState) => {
  const {branchInfo, clientPaymentData, clientTips, clientPaymentAmount} = getState();
  dispatch(showLoading('מבצע תשלום...\n' +
      'נא לא לסגור את הדפדפן'));

  const paymentData = [{
    amount: clientPaymentAmount,
    tips: +clientTips * 100
  }];

  const data = {
    ios_platform: navigator.userAgent.indexOf("iPhone") > 0,
    branch_id: branchInfo.branch_guid_code,
    guid_code: orderUuid,
    payments: paymentData,
  };

  const url = '/SubmitDejavooWebPayment';

  const res = await iposApi.post(url, data).then(response => response.data).catch((err) => {
    dispatch(hideLoading());
    throw err;
  });

  dispatch(hideLoading());

  return res;
};
